import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDatePipe } from 'src/app/pipes/translate-date.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormArrayFilterPipePipe } from 'src/app/pipes/form-array-filter-pipe.pipe';
import { PropertiesComponent } from 'src/app/components/properties/properties.component';
import { RightsComponent } from 'src/app/components/rights/rights.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from 'src/app/services/httpLoaderFactory.service';
import { HttpClient } from '@angular/common/http';
import { AngularMaterialModule } from 'src/app/angular-material.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AngularMaterialModule,
        TranslateDatePipe,
        FormArrayFilterPipePipe,
        PropertiesComponent,
        RightsComponent,
    ],
    exports: [CommonModule, FormsModule, TranslateDatePipe, FormArrayFilterPipePipe, PropertiesComponent, RightsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
